import { Action } from "@ngrx/store";
import { ReduxAction } from "../actions/redux.action";
import { TestOrderCodeSelectionSession } from "../models";

export function CodeSelectionSessionReducer(
  state: TestOrderCodeSelectionSession,
  action: ReduxAction
) {
  switch (action.type) {
    case "SET_TEST_ORDER_CODE_SELECTION_SESSION":
      return Object.assign({}, state, action.get());

    case "CLEAR_TEST_ORDER_SESSIONS":
    case "LOGOUT":
      return null;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reducers/code-selection-session.reducer.ts